import { Button } from '@/components/ds2'
import type { ListPage } from './cardResults'

/** What a list card lists, named in its "show more" so an older card's button pages its own list, not the thread's latest one. */
type ListSubject = 'invoices' | 'loads'

/** The chat message that asks the agent for the next page of this card's list. */
const showMoreMessage = (subject: ListSubject, nextPage: number): string => `show more ${subject} (page ${nextPage})`

/** How much of the list the table holds: "Showing 20 of 45" (a later page names its range), or where a named read was cut. */
const pageWords = (page: ListPage): string => {
    if (page.truncated) return `List cut at ${page.shown}`
    const range = page.first > 1 ? `${page.first}–${page.first + page.shown - 1}` : `${page.shown}`
    return page.total === undefined ? `Showing ${range}` : `Showing ${range} of ${page.total}`
}

/** Under a list table (plan PR-3 §2): how much of the list it is, and "Show more" while rows remain, so a page never reads as the whole list. */
export const PageFooter = ({ page, subject, onSend }: { page?: ListPage; subject: ListSubject; onSend: (message: string) => void }) => {
    if (!page) return null
    const { nextPage } = page
    return (
        <div className="flex items-center gap-2 text-xs text-foreground-muted">
            <span>{pageWords(page)}</span>
            {nextPage !== undefined && (
                <Button size="sm" variant="ghost" className="ml-auto" onClick={() => onSend(showMoreMessage(subject, nextPage))}>
                    Show more
                </Button>
            )}
        </div>
    )
}
